//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDelete, fetchContractResource, fetchContractChargeStandard, fetchContractChargeBillDetail, fetchChangeChargeStatus } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  props: {
    showDialog: Boolean,
    constractObj: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      areaId: '',
      title: '',
      contractState: '',
      // 合同状态
      resourceQuery: {
        page: 1,
        limit: 10
      },
      chargeStandardQuery: {
        page: 1,
        limit: 10
      },
      chargeBillQuery: {
        page: 1,
        limit: 10
      },
      resourceTotal: 0,
      chargeStandardTotal: 0,
      chargeBillTotal: 0,
      resourceList: [],
      // 租用房间/车位
      chargeStandardList: [],
      // 收费标准
      chargeBillList: [],
      // 合同账单明细
      multipleSelection: [],
      loading: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.getResourceList();
      this.getChargeStandardList();
      this.getChargeBillList();
      console.log(this.constractObj, 'constractObj');
    },
    getResourceList: function getResourceList() {
      var _this = this;

      this.resourceQuery.id = this.constractObj.id;
      fetchContractResource(this.resourceQuery).then(function (res) {
        _this.resourceList = res.data.data;
        _this.resourceTotal = res.data.total;
      });
    },
    getChargeStandardList: function getChargeStandardList() {
      var _this2 = this;

      this.chargeStandardQuery.id = this.constractObj.id;
      fetchContractChargeStandard(this.chargeStandardQuery).then(function (res) {
        _this2.chargeStandardList = res.data.data;
        _this2.chargeStandardTotal = res.data.total;
      });
    },
    getChargeBillList: function getChargeBillList() {
      var _this3 = this;

      this.chargeBillQuery.id = this.constractObj.id;
      fetchContractChargeBillDetail(this.chargeBillQuery).then(function (res) {
        _this3.chargeBillList = res.data.data;
        _this3.chargeBillTotal = res.data.total;
      });
    },
    handleUpdate: function handleUpdate() {
      this.$emit('handCancle', 'change');
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      this.$confirm('你确定是要删除该合同, 是否继续?', '提示').then(function () {
        fetchDelete([_this4.constractObj.id]).then(function (res) {
          if (res.data.code === 200) {
            _this4.$emit('handCancle');

            _this4.Alert({
              alertType: 'delete'
            });
          }
        });
      });
    },
    // 销毁
    handleDestruction: function handleDestruction() {
      var _this5 = this;

      this.$confirm('你确定是要销毁该合同, 是否继续?', '提示').then(function () {
        fetchChangeChargeStatus({
          id: _this5.constractObj.id,
          leaseType: _this5.constractObj.leaseType,
          contractType: 6
        }).then(function (res) {
          if (res.data.code === 200) {
            _this5.Alert({
              alertType: 'update',
              message: '合同已销毁'
            });

            _this5.$emit('handCancle');
          }
        });
      });
    },
    // 续签
    handleRenewal: function handleRenewal() {
      this.$emit('handCancle', 'renewal');
    },
    // 退租
    handleRentCancellation: function handleRentCancellation() {
      this.$emit('handCancle', 'rentCancellation');
    },
    // 终止
    handleTermination: function handleTermination() {
      var _this6 = this;

      this.$confirm('你确定是要终止该合同, 是否继续?', '提示').then(function () {
        fetchChangeChargeStatus({
          id: _this6.constractObj.id,
          leaseType: _this6.constractObj.leaseType,
          contractType: 4
        }).then(function (res) {
          if (res.data.code === 200) {
            _this6.Alert({
              alertType: 'update',
              message: '合同已终止'
            });

            _this6.$emit('handCancle');
          }
        });
      });
    },
    handleResourceSizeChange: function handleResourceSizeChange(val) {
      this.resourceQuery.limit = val;
      this.getList();
    },
    handleResourceCurrentChange: function handleResourceCurrentChange(val) {
      this.resourceQuery.page = val;
      this.getList();
    },
    handleChargeSizeChange: function handleChargeSizeChange(val) {
      this.chargeStandardQuery.limit = val;
      this.getList();
    },
    handleChargeCurrentChange: function handleChargeCurrentChange(val) {
      this.chargeStandardQuery.page = val;
      this.getList();
    },
    handleChargeBillSizeChange: function handleChargeBillSizeChange(val) {
      this.chargeBillQuery.limit = val;
      this.getList();
    },
    handleChargeBillCurrentChange: function handleChargeBillCurrentChange(val) {
      this.chargeBillQuery.page = val;
      this.getList();
    },
    handCancle: function handCancle() {
      this.dialogFormVisible = false;
      this.dialogCustomerVisible = false;
      this.dialogHistoryVisible = false;
    }
  }
};